if (!customElements.get('metal-swatches')) {
  customElements.define(
    'metal-swatches',
    class MetaSwatches extends HTMLElement {
      classes = {
        active: 'metal-swatches__item--active',
        cardHover: 'card-wrapper--disable-media-hover',
      };

      selectors = {
        item: '.metal-swatches__item',
        cardLink: '.card__heading > a',
        cardPrice: '.card-information .price__regular .price-item',
        cardComparePrice: '.card-information .price__sale .price-item',
        card: '.card-wrapper',
        carProductMedia: '.card__media .media',
        mediaHoverEffect: '.media.media--hover-effect',
        badges: '.card__badges',
        cardInner: '.card__inner',
      };

      constructor() {
        super();

        this.swatches = this.querySelectorAll(this.selectors.item);
        this.mediaHoverEnabled = this.swatches[0]
          .closest(this.selectors.card)
          .querySelector(this.selectors.mediaHoverEffect);
        this.setupEventListeners();
      }

      setupEventListeners() {
        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', this.onSwatchClick.bind(this));
        });

        const desktop = window.matchMedia('(min-width: 1024px)').matches;
        if (desktop && this.mediaHoverEnabled) {
          const card = this.closest(this.selectors.card);
          if (card) {
            this.addEventListener('mouseenter', () => {
              card.classList.add(this.classes.cardHover);
            });
            this.addEventListener('mouseleave', () => {
              card.classList.remove(this.classes.cardHover);
            });
          }
        }
      }

      getSwatchSettings(swatch) {
        const settings = swatch.dataset.swatchSettings;

        if (settings) {
          try {
            return JSON.parse(settings);
          } catch (error) {
            console.error('Error parsing swatch settings JSON:', error);
            return {};
          }
        }
      }

      onSwatchClick(event) {
        const swatch = event.currentTarget;

        this.swatches.forEach((item) => {
          item.classList.remove('metal-swatches__item--active');
        });

        swatch.classList.add('metal-swatches__item--active');

        const card = swatch.closest(this.selectors.card);

        if (!card) return;

        const {
          productId: swatchProductId,
          url: swatchLink,
          title: swatchTitle,
          price: swatchPrice,
          compareAtPrice: swatchComparePrice,
          media: swatchMedia,
          badges: swatchBadgesContainer,
        } = this.getSwatchSettings(swatch);

        const cardLinks = card.querySelectorAll(this.selectors.cardLink);
        const cardPrice = card.querySelector(this.selectors.cardPrice);
        const cardComparePrice = card.querySelector(this.selectors.cardComparePrice);
        const cardProductMedia = card.querySelector(this.selectors.carProductMedia);
        const badgesContainer = card.querySelector(this.selectors.badges);

        cardLinks.forEach((cardLink) => {
          cardLink.setAttribute('href', swatchLink);
          cardLink.innerHTML = swatchTitle;
        });

        if (cardPrice) {
          cardPrice.innerHTML = swatchPrice;
        }

        if (cardComparePrice) {
          cardComparePrice.innerHTML = swatchComparePrice;
        }

        if (cardProductMedia) {
          cardProductMedia.innerHTML = swatchMedia;
        }

        // Convert badges HTML string back to DOM elements
        badgesContainer.outerHTML = swatchBadgesContainer;
      }
    },
  );
}
